export default "__VITE_ASSET__LYYcyXwd__"